<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="121px">
              <el-form-item label="配置时间：" required>
                <el-col :span="11">
                    <el-form-item prop="date1">
                        <el-date-picker type="month" placeholder="选择日期" value-format="yyyy-MM" v-model="form.beginTime" style="width: 100%;" @change="changFun"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col style="text-align:center;" :span="2">-</el-col>
                <el-col :span="11">
                    <el-form-item prop="date2">
                        <el-date-picker type="month" placeholder="选择日期" value-format="yyyy-MM" v-model="form.endTime" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item ref="shopAchAmount" label="门店总业绩：" prop="shopAchAmount" :rules="$rules.money">
              <el-input v-model="form.shopAchAmount" placeholder="请输入门店总业绩" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="productAchAmount" label="产品总业绩：" prop="productAchAmount" :rules="$rules.money">
              <el-input v-model="form.productAchAmount" placeholder="请输入产品总业绩" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="repairAchAmount" label="修护总业绩：" prop="repairAchAmount" :rules="$rules.money">
              <el-input v-model="form.repairAchAmount" placeholder="请输入修护总业绩" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="otherServeAchAmount" label="其他业绩：" prop="otherServeAchAmount" :rules="$rules.money">
              <el-input v-model="form.otherServeAchAmount" placeholder="请输入其他业绩" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="rechargeTargetAmount" label="充值目标：" prop="rechargeTargetAmount" :rules="$rules.money">
              <el-input v-model="form.rechargeTargetAmount" placeholder="请输入充值目标" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="commissionTargetAmount" label="提成目标：" prop="commissionTargetAmount" :rules="$rules.money">
              <el-input v-model="form.commissionTargetAmount" placeholder="请输入提成目标" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="footTotal" label="泡脚总个数：" prop="footTotal" :rules="$rules.money">
              <el-input v-model="form.footTotal" placeholder="请输入泡脚总个数" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item ref="memberTotal" label="会员总个数：" prop="memberTotal" :rules="$rules.money">
              <el-input v-model="form.memberTotal" placeholder="请输入会员总个数" maxlength="8"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
        beginTime: new Date(),
        endTime: new Date()
      },
      columns: [],
      staffList: [],
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.form.beginTime = this.formatMonth(new Date())
        this.form.endTime = this.form.beginTime
        if (org) {
          this.addEditTitle = "配置门店月业绩目标";
          this.$api.get(this.$url.saleTargetShop.get, {
              shopId: this.$store.getters.ShopInfo.shopId,
              beginTime: this.form.beginTime,
              endTime: this.form.endTime
            }).then(res => {
              if (res) {
                this.form = res;
              }
            })
            .catch(error => {});
        }
        this.addEditShow = true;
      });
    },
    changFun () {
        this.$api.get(this.$url.saleTargetShop.get, {
            shopId: this.$store.getters.ShopInfo.shopId,
            beginTime: this.form.beginTime,
            endTime: this.form.endTime
        }).then(res => {
            if (res) {
            this.form = res;
            }
        })
        .catch(error => {});
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    back () {
        this.addEditShow = false;
    },
    onSubmit(values) {
        if (!Number(this.form.shopAchAmount)) {
          return this.$message.error("门店业绩不能为空和零")
        } else if (!Number(this.form.productAchAmount)) {
          return this.$message.error("产品业绩不能为空和零")
        } else if (!Number(this.form.repairAchAmount)) {
          return this.$message.error("修护业绩不能为空和零")
        } else if (!Number(this.form.otherServeAchAmount)) {
          return this.$message.error("其他业绩不能为空和零")
        } else if (!Number(this.form.rechargeTargetAmount)) {
          return this.$message.error("充值目标不能为空和零")
        } else if (!Number(this.form.commissionTargetAmount)) {
          return this.$message.error("提成目标不能为空和零")
        } else if (!Number(this.form.footTotal)) {
            return this.$message.error("泡脚个数不能为空和零")
        } else if (!Number(this.form.memberTotal)) {
            return this.$message.error("新增会员不能为空和零")
        } else if (Number(this.form.shopAchAmount) < Number(this.form.productAchAmount) + Number(this.form.repairAchAmount) + Number(this.form.otherServeAchAmount)) {
            return this.$message.error("修护业绩,产品销售业绩和其他业绩之和要小于等于门店业绩")
        }
        this.$refs.form.validate((valid, object) => {
            if (valid) {
                this.form.shopId = this.$store.getters.ShopInfo.shopId;
            this.$api.post(this.$url.saleTargetShop.save, this.form)
                .then(res => {
                if (res) {
                    this.addEditShow = false;
                    this.$message.success("操作成功");
                    this.$emit("change", true);
                }
                })
                .catch(error => {});
            }
        });
    }
  }
};
</script>
<style scoped lang="less">
/deep/ .el-input--small .el-input__inner {
  width: 200px;
  height: 40px;
  line-height: 40px;
}
/deep/ div .el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  line-height: 40px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
.pay-mains {
  padding: 20px;
}
</style>